var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C8 16.6562 6.65625 18 5 18C3.31562 18 2 16.6562 2 15C0.895313 15 0 14.1031 0 13V4C0 2.89531 0.895313 2 2 2H11C12.1031 2 13 2.89531 13 4V5H14.3344C14.8 5 15.2437 5.18438 15.5719 5.5125L18.4875 8.42812C18.8156 8.75625 19 9.2 19 9.66563V13.5H19.25C19.6656 13.5 20 13.8344 20 14.25C20 14.6656 19.6656 15 19.25 15H18C18 16.6562 16.6562 18 15 18C13.3156 18 12 16.6562 12 15H8ZM11 3.5H2C1.72375 3.5 1.5 3.72375 1.5 4V13C1.5 13.275 1.72375 13.5 2 13.5H2.40125C2.92 12.6031 3.89062 12 5 12C6.10938 12 7.08125 12.6031 7.6 13.5H11C11.275 13.5 11.5 13.275 11.5 13V4C11.5 3.72375 11.275 3.5 11 3.5ZM14.5125 6.57188C14.4656 6.525 14.4031 6.5 14.3344 6.5H13V9.5H17.4375C17.4344 9.49687 17.4312 9.49063 17.4281 9.4875L14.5125 6.57188ZM5 13.5C4.17188 13.5 3.5 14.1719 3.5 15C3.5 15.8281 4.17188 16.5 5 16.5C5.82812 16.5 6.5 15.8281 6.5 15C6.5 14.1719 5.82812 13.5 5 13.5ZM15 16.5C15.8281 16.5 16.5 15.8281 16.5 15C16.5 14.1719 15.8281 13.5 15 13.5C14.1719 13.5 13.5 14.1719 13.5 15C13.5 15.8281 14.1719 16.5 15 16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.0c6d583a56bf3372c6195c2faff63678.svg";
export { ForwardRef as ReactComponent };